<template>
  <div class="wrap">
    <!-- {{formData}} -->
    <div class="inner">
      <!-- 表单box start -->
      <div class="HealthformBox">
        <form action class="HealtInfoForm">
          <div class="InfoForm_item flex">
            <label for="name" class="commonLabel">
              <i>姓名:</i>
            </label>
            <input
              v-model="formData.userName"
              type="text"
              name="userName"
              id="name"
              placeholder="请你输入姓名"
            />
          </div>
          <div class="InfoForm_item InfoForm_Sex flex">
            <label for="sex" class="commonLabel">
              <i>性别:</i>
            </label>
            <div class="select-box">
              <span>{{sexName}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_SEX')">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_birthDate flex">
            <label for="birthDate" class="commonLabel">
              <i>出生日期:</i>
            </label>
            <div class="select-box">
              <span>{{formData.birthDate}}</span>
              <div class="img-box" @click="handleDate()">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_address flex">
            <label for="address" class="commonLabel">
              <i>联系地址:</i>
            </label>
            <input v-model="formData.postAddress" type="text" name="address" id="address" />
          </div>

          <div class="InfoForm_item InfoForm_FamousRace flex">
            <label for="FamousRace" class="commonLabel">
              <i>民族：</i>
            </label>
            <input v-model="formData.nationCode" type="text" name="FamousRace" id="FamousRace" />
          </div>

          <div class="InfoForm_item InfoForm_BloodType flex">
            <label for="BloodType" class="commonLabel">
              <i>血型:</i>
            </label>
            <div class="select-box">
              <span>{{bloodName}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_BLOOD_CODE')">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_MaritalStatus flex">
            <label for="MaritalStatus" class="commonLabel">
              <i>婚姻状况:</i>
            </label>
            <div class="select-box">
              <span>{{maritalName}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_MARITAL_CODE')">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_Education flex">
            <label for="Education" class="commonLabel">
              <i>学历:</i>
            </label>
            <div class="select-box">
              <span>{{educationName}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_EDU_CODE')">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>

          <div class="InfoForm_item InfoForm_Occupation flex">
            <label for="Document_Occupation" class="commonLabel">
              <i>职业:</i>
            </label>
            <input v-model="formData.occupationName" type="text" name="Occupation" id="Occupation" />
          </div>

          <div class="InfoForm_item InfoForm_hieght flex">
            <label for="hieght" class="commonLabel">
              <i>身高:</i>
            </label>
            <input
              v-model="formData.heightData"
              type="text"
              name="hieght"
              id="hieght"
              placeholder="cm"
            />
          </div>

          <div class="InfoForm_item InfoForm_weight flex">
            <label for="weight" class="commonLabel">
              <i>体重:</i>
            </label>
            <input
              v-model="formData.weightData"
              type="text"
              name="weight"
              id="weight"
              placeholder="Kg"
            />
          </div>
          <div class="InfoForm_item InfoForm_Allergens flex">
            <label for="Allergens" class="commonLabel">
              <i>过敏物质:</i>
            </label>
            <input v-model="formData.srsA" type="text" name="Allergens" id="Allergens" />
          </div>

          <div class="InfoForm_item InfoForm_Pastmedicalhistory flex">
            <label for="Pastmedicalhistory" class="commonLabel">
              <i>既往病史:</i>
            </label>
            <input
              v-model="formData.medicalHistory"
              type="text"
              name="Pastmedicalhistory"
              id="Pastmedicalhistory"
            />
          </div>

          <div class="InfoForm_item InfoForm_Familyhistory flex">
            <label for="Familyhistory" class="commonLabel">
              <i>家族病史:</i>
            </label>
            <input
              v-model="formData.familyHistory"
              type="text"
              name="Familyhistory"
              id="Familyhistory"
            />
          </div>
          <div class="InfoForm_item InfoForm_physicalexercise flex">
            <label for="physicalexercise" class="commonLabel">
              <i>体育锻炼:</i>
            </label>

            <div class="select-box">
              <span>{{workoutName}}</span>
              <div class="img-box" @click="handleSelectBox('SYS_TAKE_EXERCISE')">
                <img src="../assets/image/common/pull.png" />
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- 表单box end -->

      <!-- 底部按钮div区域 -->
      <div class="bottomBtnBox flex">
        <div class="containerBtn" @click="handleSubmit">
          <button class="nextBtn">保存</button>
        </div>
      </div>

      <div id="demo">
        <calendar
          :show.sync="isShowDate"
          :mode="dateMode"
          @change="onChange"
          :defaultDate="formData.birthDate"
        />
      </div>
    </div>

    <mask-box
      :isShow="isSexShow"
      @handle-close="handleSexClose"
      :dataList="sexList"
      title="性别"
      @handle-select="handleSelect"
    ></mask-box>

    <mask-box
      :isShow="isBloodShow"
      @handle-close="handleBloodClose"
      :dataList="bloodList"
      title="血型"
      @handle-select="handleBloodSelect"
    ></mask-box>

    <mask-box
      :isShow="isMaritalShow"
      @handle-close="handleMaritalClose"
      :dataList="maritalList"
      title="婚姻状况"
      @handle-select="handleMaritaSelect"
    ></mask-box>

    <mask-box
      :isShow="iseducationShow"
      @handle-close="handleEducationClose"
      :dataList="educationList"
      title="学历"
      @handle-select="handleEducationSelect"
    ></mask-box>

    <mask-box
      :isShow="isworkOutShow"
      @handle-close="handleWorkoutClose"
      :dataList="workOutList"
      title="体育锻炼"
      @handle-select="handleWorkoutSelect"
    ></mask-box>
    <div id="date">
      <calendar :show.sync="isShowDate" @change="onChange" :defaultDate="formData.birthDate" />
      <!-- <inlineCalendar /> -->
    </div>
  </div>
</template>


<script>
import { getApi, postApi } from '../api/index.js'
import MaskBox from '../components/mask-box'
import { setTimeout } from 'timers'
export default {
  components: {
    'mask-box': MaskBox
  },
  data() {
    return {
      sexList: [],
      isSexShow: false,
      formData: {
        userName: '',
        sexCode: '',
        birthDate: '',
        postAddress: '',
        nationCode: '',
        bloodCode: '',
        maritalCode: '',
        eduCode: '',
        occupationName: '',
        heightData: '',
        weightData: '',
        srsA: '',
        medicalHistory: '',
        familyHistory: '',
        isWorkout: ''
      },
      sexName: '',
      isBloodShow: false,
      bloodName: '',
      maritalName: '',
      bloodList: [],
      maritalList: [],
      isMaritalShow: false,
      educationName: '',
      educationList: [],
      iseducationShow: false,

      workoutName: '',
      workOutList: [],
      isworkOutShow: false,
      isShowDate: false,
      dateMode: '',
      btnDisabled: false
    }
  },
  created() {
    this.getDetail()
    this.getSexFun()
    this.getBloodFun()
    this.getMaritaFun()
    this.getEducationFun()
    this.getWorkout()
  },
  methods: {
    getDetail() {
      getApi({ url: '/member/getMemberArchive', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              let data = res.data
              this.formData.userName = data.userName
              this.formData.sexCode = data.sexCode
              this.sexName = data.sexCodeStr
              this.formData.birthDate = data.birthDateStr
              this.formData.postAddress = data.postAddress
              this.formData.nationCode = data.nationCode
              this.formData.bloodCode = data.bloodCode
              this.bloodName = data.bloodCodeStr
              this.formData.maritalCode = data.maritalCode
              this.maritalName = data.maritalCodeStr
              this.formData.eduCode = data.eduCode
              this.educationName = data.eduCodeStr
              this.formData.occupationName = data.occupationName
              this.formData.heightData = data.heightData
              this.formData.weightData = data.weightData
              this.formData.srsA = data.srsA
              this.formData.medicalHistory = data.medicalHistory
              this.formData.familyHistory = data.familyHistory
              this.formData.isWorkout = data.isWorkout
              this.workoutName = data.isWorkoutStr
            }
          }
        })
        .catch(res => {})
    },
    getSexFun() {
      getApi({ url: '/common/dict/SYS_SEX', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              this.sexList = res.data
            }
          }
        })
        .catch(res => {})
    },
    getBloodFun() {
      getApi({ url: '/common/dict/SYS_BLOOD_CODE', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            if (res.data) {
              this.bloodList = res.data
            }
          }
        })
        .catch(res => {})
    },
    handleBloodSelect(item) {
      this.formData.bloodCode = item.dicCode
      this.bloodName = item.dicName
      this.isBloodShow = false
    },
    handleSelect(item) {
      this.formData.sexCode = item.dicCode
      this.sexName = item.dicName
      this.isSexShow = false
    },
    handleSexClose() {
      this.isSexShow = false
    },
    handleBloodClose() {
      this.isBloodShow = false
    },

    getMaritaFun() {
      getApi({ url: '/common/dict/SYS_MARITAL_CODE', query: {} })
        .then(res => {
          if (res && res.resCode == 0) {
            this.maritalList = res.data
          }
        })
        .catch(res => {
          console.log('获取失败婚姻状况数据失败')
        })
    },
    handleMaritaSelect(item) {
      this.formData.maritalCode = item.dicCode
      this.maritalName = item.dicName
      this.isMaritalShow = false
    },

    handleMaritalClose() {
      this.isMaritalShow = false
    },

    getEducationFun() {
      getApi({ url: '/common/dict/SYS_EDU_CODE', query: {} })
        .then(res => {
          // console.log(res);
          if (res && res.resCode == 0) {
            this.educationList = res.data
          }
        })
        .catch(res => {
          console.log('获取学历数据失败')
        })
    },
    handleEducationSelect(item) {
      this.formData.eduCode = item.dicCode
      this.educationName = item.dicName
      this.iseducationShow = false
    },
    handleEducationClose() {
      this.iseducationShow = false
    },
    getWorkout() {
      getApi({ url: '/common/dict/SYS_TAKE_EXERCISE', uery: {} })
        .then(res => {
          this.workOutList = res.data
        })
        .catch(res => {
          console.log('获取体育锻炼次数失败')
        })
    },
    handleWorkoutSelect(item) {
      this.formData.isWorkout = item.dicCode
      this.workoutName = item.dicName
      this.isworkOutShow = false
    },
    handleWorkoutClose() {
      this.isworkOutShow = false
    },

    handleSelectBox(str) {
      if (str === 'SYS_SEX') {
        this.isSexShow = true
      } else if (str === 'SYS_BLOOD_CODE') {
        this.isBloodShow = true
      } else if (str === 'SYS_MARITAL_CODE') {
        this.isMaritalShow = true
      } else if (str === 'SYS_EDU_CODE') {
        this.iseducationShow = true
      } else if (str === 'SYS_TAKE_EXERCISE') {
        this.isworkOutShow = true
      }
    },
    // handleDate(mode) {
    //   this.isShowDate = true
    //   this.dateMode = mode
    // },
    handleDate() {
      let date = new Date()
      let y = date.getFullYear()
      let m = this.tf(date.getMonth() + 1)
      let d = this.tf(date.getDate())
      let time = y + '-' + m + '-' + d
      // this.isShowDate = true
      this.$picker.show({
        type: 'datePicker',
        date: this.formData.birthDate || '1990-01-01',
        endTime: time, //截至时间
        startTime: '1880-01-01', //开始时间
        onOk: date => {
          this.formData.birthDate = date
        }
      })
    },
    tf(i) {
      return (i < 10 ? '0' : '') + i
    },
    onChange(date) {
      this.formData.birthDate = date.format('YYYY-MM-DD')
      this.isShowDate = false
    },
    checkData(callback) {
      if (!this.formData.userName) {
        this.$toast('请输入姓名！')
        return
      } else if (!this.formData.sexCode) {
        this.$toast('请选择性别！')
        return
      } else if (!this.formData.birthDate) {
        this.$toast('请选择出生日期！')
        return
      } else {
        callback && callback()
      }
    },
    handleSubmit() {
      this.checkData(() => {
        if (!this.btnDisabled) {
          let param = {
            ...this.formData
          }
          this.btnDisabled = true
          postApi({ url: '/member/updateMemberArchive', query: param })
            .then(res => {
              if (res && res.resCode == 0) {
                this.$toast('操作成功')
                setTimeout(() => {
                  this.btnDisabled = false
                  this.$router.push(
                    {
                      path: 'my'
                    },
                    2000
                  )
                })
              } else {
                this.$toast(res.resMsg || '网络错误，请重试！')
                this.btnDisabled = false
              }
            })
            .catch(res => {
              this.$toast(res.resMsg || '网络错误，请重试！')
              this.btnDisabled = false
            })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  background-color: #fff;
  height: 100%;
  padding-bottom: 1.3rem;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.inner {
  padding: 0 0.26rem;
  box-sizing: border-box;
  width: 100%;
}

.bottomInfo {
  margin-top: 0.32rem;
  width: 100%;

  .bottomInfoItem {
    width: 100%;

    span {
      color: rgb(153, 153, 153);
      font-size: 0.24rem;
      letter-spacing: -0.006rem;
    }
  }
}

.bottomBtnBox {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1.22rem;
  background-color: rgb(255, 255, 255);

  .containerBtn {
    width: 4rem;
    height: 0.88rem;
    margin: 0.15rem auto;

    .nextBtn {
      width: 100%;
      height: 100%;
      background-color: rgb(77, 205, 112);
      border: 0px transparent solid;
      border-radius: 0.2rem;
      font-size: 0.3rem;
      color: rgb(255, 255, 255);
    }
  }
}

.HealthformBox {
  width: 100%;
  .InfoForm {
    width: 100%;
  }

  .InfoForm_item {
    input,
    .select-box {
      font-size: 0.3rem;
      // padding-left: 2rem;
      text-align: right;
      padding-right: 0.33rem;
      width: 60%;
      height: 0.9rem;
      border: 0rem transparent solid;
      line-height: 0.9rem;
      .img-box {
        padding-left: 0.16rem;
        display: inline-block;
      }
      img {
        width: 0.28rem;
      }
    }

    width: 100%;
    background-color: #fff;
    border-bottom: rgb(238, 238, 238) solid 0.02rem;

    .commonLabel {
      padding-left: 0.26rem;
      display: block;
      width: 40%;
      height: 100%;
      // text-align: center;
      line-height: 0.9rem;
      letter-spacing: -0.007rem;
      span {
        color: rgb(255, 0, 0);
        font-size: 0.3rem;
      }
      i {
        font-size: 0.3rem;
      }
    }
  }
}
</style>